import Service from "../AuthService";

const District = {
    getDistricts(code) {
        return Service.get(`districts/${code}`);
    }
};

export default District;
